import React, { useState } from 'react';
import Css from './Query.module.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Query() {
  let [errMsg, setMsg] = useState("");
  

  function handleSubmit(event) {
    event.preventDefault();
    let data = {
      name: event.target.name.value,
      email: event.target.email.value,
      message: event.target.message.value
    }
    if (data.name === "") setMsg("Please enter name!");
    else if (data.email === "") setMsg("Please enter email!");
    else if (data.message === "") setMsg("Please drop any message or query!");
    else {
      fetch("https://portfolio__api.deta.dev/",
        {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify(data)
        })
        .then((res) => { return res.json() })
        .then((data) => {
          if (data.msg === "success"){
            toast.success("Sent!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,

            });
            event.target.name.value = "";
            event.target.email.value ="";
            event.target.message.value ="";
          }
          if (data.msg === "failure" || data.msg === "Error occured")
            toast.error("Failure, try again ! ", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

        })
    }
  }

  function handleChange() {
    setMsg("");
  }

  return <div id='Query' className={Css.container}>
    <h1 className={Css.mainHeading}>Get in Touch</h1>

    <form onSubmit={handleSubmit} className={Css.inputContainer}>

      <p className={Css.errMsg}>{errMsg}</p>

      <input name='name'onChange={handleChange} className={`${Css.input} ${Css.Name}`} type="text" placeholder='Name' />

      <input name='email' onChange={handleChange} className={`${Css.input} ${Css.Email}`} type="email" placeholder='Email' />

      <textarea name='message' onChange={handleChange} className={`${Css.input} ${Css.Textarea}`} placeholder='Any Qery or Message'></textarea>

      <button type='submit' className={Css.btn}>Send</button>

    </form>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      theme="colored"
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={1}
    />
  </div>;
}
